import React, { Component } from "react";
import { observable, toJS } from "mobx";
import {
  Button,
  Popover,
  Position,
  Spinner,
  Icon,
} from "@blueprintjs/core";
import { DatePicker } from "@blueprintjs/datetime";
import moment, { parseZone } from "moment";
import $ from "jquery";
import _ from "lodash";
import "fullcalendar";
import "fullcalendar-scheduler";
import "fullcalendar/dist/fullcalendar.css";
import "fullcalendar-scheduler/dist/scheduler.css";
import { inject, observer } from "mobx-react";
import { socket, channels } from "../services/pusher";
import Toast from "helpers/toaster";
import { router } from "../App";
import Lockr from "lockr";
import { currentTimezone } from "../helpers/time";
import { Helmet } from "react-helmet";
import UnassignedJob from "../pages/jobs/unassigned_job";
import IncompleteJob from "../pages/jobs/incomplete_job";
import ServiceTypePicker from "components/ServiceTypePicker";
import TechnicianPicker from "components/TechnicianPicker";
import PriorityTagPicker from "components/PriorityTagPicker";
import DispatchViewBar from "components/DispatchViewBar";
import SearchFiltersToolbar from "components/SearchFiltersToolbar";
import { bookedHoursByTechnician, workloadMeterHtml } from "helpers/technicianWorkload";
import { setDispatchDragging, whenNotDragging } from "helpers/dispatchDraggable";
import { TIMELINE_SLOT_WIDTH, TIMELINE_MIN_LAYOUT_MINUTES } from "helpers/timelineLayout";
import { rememberCalendarEdit } from "helpers/localCalendarEdits";
import { priorityMapping } from "helpers/priorityTag";

const isInvoicedJob = (event) =>
  (event.job_status || event.status) === "invoiced";

@inject("dashboard", "viewStore", "store", "jobStore")
@observer
class DispatchBoard extends Component {
  @observable zoom_in = false;
  @observable currentSideTab = "";

  constructor(props) {
    super(props);
    let {
      dashboard,
      dashboard: { loadCalendarUsers },
    } = this.props;
    this.loadUsers = loadCalendarUsers.bind(dashboard);
  }

  state = {
    isBoxVisible: false,
  };

  toggleBox = (sideTab) => {
    if (sideTab != this.currentSideTab) {
      if (this.state.isBoxVisible === true) {
        this.currentSideTab = sideTab;
      } else {
        this.currentSideTab = sideTab;
        this.setState((prevState) => ({
          isBoxVisible: !prevState.isBoxVisible,
        }));
      }
    } else {
      this.currentSideTab = sideTab;
      this.setState((prevState) => ({ isBoxVisible: !prevState.isBoxVisible }));
    }
  };

  componentWillUnmount() {
    const currentUser = Lockr.get("currentUser");
    channels.dispatchBoard().unbind();
    if (this.cancelHoverCardHide) this.cancelHoverCardHide();
    if (currentUser) {
      socket.unsubscribe(`${currentUser.attributes.tenant_name}-dispatchBoard`);
    }
  }

  datePicker(date) {
    return (
      <DatePicker
        className="dispatch-date-picker"
        defaultValue={moment.unix(date).toDate()}
        onChange={this.goToDate.bind(this)}
        showActionsBar={true}
        maxDate={moment().add(500, "years").toDate()}
        minDate={moment().subtract(500, "years").toDate()}
      />
    );
  }

  goToDate = (date) => {
    if (
      date &&
      this.props.viewStore.dashboardSearch.date !== moment(date).unix()
    ) {
      this.props.viewStore.dashboardSearch.date = moment(date).unix();
      this.props.viewStore.dashboard();
      this.renderCalendar();
      $("#calendar").fullCalendar("gotoDate", date);
    }
  };

  getPriorityMapping(priority) {
    return priorityMapping(priority);
  }

  renderCalendar() {
    let {
      updateJob,
      props: {
        viewStore: {
          dashboardSearch: { view, date },
        },
        jobStore: { loadUnassignedJobs },
        dashboard,
        dashboard: { loadCalendarAssignments, loadCalendarUsers },
      },
    } = this;

    // Day meter beside each technician on the timeline (see
    // helpers/technicianWorkload): hours booked on the shown day out of 8.
    // Refetch, but never mid-drag (it would cut the drag off); a refetch
    // asked for during a drag runs once when the drag ends.
    const refetchCalendar = () =>
      whenNotDragging("refetch", () => $("#calendar").fullCalendar("refetchEvents"));

    // Remember where the user just put a job so a refetch that still has the
    // old position (the server lags a moment) doesn't snap it back.
    const rememberEdit = (event, extraIds = []) => {
      const isTimeline = $("#calendar").fullCalendar("getView").name === "timelineDay";
      const start = moment(event.start);
      let fields;
      if (isTimeline) {
        const realEnd = moment(event.end);
        const minutes = Math.max(0, realEnd.diff(start, "minutes"));
        fields = {
          start: start.format(),
          end: start.clone().add(Math.max(minutes, TIMELINE_MIN_LAYOUT_MINUTES), "minutes").format(),
          endForDisplay: realEnd.format(),
          realMinutes: minutes,
          resourceId: event.resourceId,
        };
      } else {
        fields = { start: start.format(), end: event.end ? moment(event.end).format() : undefined };
      }
      [event.id, ...extraIds].forEach((id) => rememberCalendarEdit(id, fields));
    };

    let workloadTimer;
    const renderWorkloadMeters = (view) => {
      if (!view || view.name !== "timelineDay") return;
      const events = $("#calendar").fullCalendar("clientEvents");
      const hours = bookedHoursByTechnician(events, view.start, view.end);
      $("#calendar .fc-resource-area tr[data-resource-id]").each(function () {
        const id = $(this).attr("data-resource-id");
        const cell = $(this).children("td").first();
        cell.find(".tech-load").remove();
        if (id === "0") return;
        cell.append(workloadMeterHtml(hours[id] || 0));
      });
    };

    $("#calendar").fullCalendar({
      schedulerLicenseKey: "GPL-My-Project-Is-Open-Source",
      timeZone: currentTimezone(),
      header: false,
      height: "parent",
      defaultView: view,
      editable: true,
      defaultDate: moment.unix(Number(date)),
      businessHours: {
        dow: [1, 2, 3, 4, 5],
        start: "06:00",
        end: "17:30",
      },
      resourceAreaWidth: "250px",
      resourceLabelText: "Team",
      nowIndicator: true,
      // Card colours and hover live in search-filters-bar.scss (dispatch board).
      eventBackgroundColor: "#FFFFFF",
      eventBorderColor: "#E2E6EF",
      eventTextColor: "#022047",
      scrollTime: `${new Date().getHours()}:00:00`,
      slotDuration: { hours: 0.25 },
      // Fixed scale so card widths and the layout threshold agree
      // (helpers/timelineLayout).
      slotWidth: TIMELINE_SLOT_WIDTH,
      droppable: true,
      dropAccept: ".fc-events",
      eventReceive: function (info) {
        let endDate = moment(info.end_date);
        let startDate = moment(info.start_date);
        let seconds = endDate.diff(startDate, "seconds");
        // Week view drops land on a day, not a time: keep the job's original
        // time of day (updateJob leaves technician and status alone).
        if (!info.start.hasTime()) {
          info.start = moment(info.start.format("YYYY-MM-DD") + "T" + startDate.format("HH:mm:ss"));
          info.allDay = false;
        }
        info.end = moment(info.start);
        info.end.add(seconds, "seconds");
        info.end_date = info.end;
        info.start_date = info.start;
        info.endForDisplay = info.end;
        info.realMinutes = Math.round(seconds / 60);
        rememberEdit(info, info.job_id ? [info.job_id] : []);
        // Keep the dropped card on screen until a refetch returns the saved
        // job: the server's search results lag a moment behind the save, and
        // a plain refetch drops client-side events, so the job vanished until
        // a page refresh. The card is "stick" (see the panels' drop data).
        info.__dropped = true;
        const droppedJobId = info.job_id || info.id;
        const matchesDrop = (event) =>
          event.id === info.id || (event.jobId && event.jobId === droppedJobId);
        const settle = (attempt) => {
          refetchCalendar();
          setTimeout(() => {
            const saved = $("#calendar").fullCalendar(
              "clientEvents",
              (event) => !event.__dropped && matchesDrop(event)
            );
            if (saved.length || attempt >= 5) {
              $("#calendar").fullCalendar(
                "removeEvents",
                (event) => event.__dropped && event._id === info._id
              );
            } else {
              settle(attempt + 1);
            }
          }, 1200);
        };
        updateJob(info).finally(() => {
          settle(1);
          // Refresh the side lists too (the panels re-attach dragging), but
          // not while another card is being dragged out of them.
          setTimeout(() => {
            whenNotDragging("panels", () => {
              window.stores.jobStore.loadUnassignedJobs();
              window.stores.jobStore.loadIncompleteJobs();
            });
          }, 1500);
        });
      },
      // The moved card already shows the new time; refetch a moment later so
      // the server's search results have caught up (otherwise it jumps back).
      // Timeline events are laid out with a padded end (see
      // helpers/timelineLayout); save the job's real end, not the padding.
      eventDrop: function (info) {
        if (info.realMinutes != null) {
          info.end = info.start.clone().add(info.realMinutes, "minutes");
        }
        rememberEdit(info);
        updateJob(info).finally(() => {
          setTimeout(refetchCalendar, 1500);
        });
      },
      eventResize: function (info, delta) {
        if (info.realMinutes != null) {
          const minutes = Math.max(15, info.realMinutes + delta.asMinutes());
          info.realMinutes = minutes;
          info.end = info.start.clone().add(minutes, "minutes");
          info.endForDisplay = info.end.clone();
        }
        rememberEdit(info);
        updateJob(info).finally(() => {
          setTimeout(refetchCalendar, 1500);
        });
      },
      // Moving or resizing a job on the calendar holds back refreshes.
      eventDragStart: () => setDispatchDragging(true),
      eventDragStop: () => setDispatchDragging(false),
      eventResizeStart: () => setDispatchDragging(true),
      eventResizeStop: () => setDispatchDragging(false),
      resourceRender: function (resource, el, view) {
        let targetResource = el[0];
        if (targetResource) {
          let html = `<img src="${resource.avatar_url}" class="resourceImage" />`;
          $(targetResource).prepend(html);
        }
        // Rows can be redrawn without the events re-rendering; refill meters.
        clearTimeout(workloadTimer);
        workloadTimer = setTimeout(
          () => renderWorkloadMeters($("#calendar").fullCalendar("getView")),
          0
        );
      },
      eventClick: function (calEvent, jsEvent, view) {
        if (calEvent.isVacation) return;
        // "Edit" in the hover card opens the edit drawer instead of the job.
        if ($(jsEvent.target).closest(".card-edit-button").length) {
          window.stores.jobStore.openEditJobDrawer(calEvent.jobId);
          return false;
        }
        // Directions open Google Maps from the user's current location.
        const directionsButton = $(jsEvent.target).closest(
          ".card-directions-button"
        );
        if (directionsButton.length) {
          window.open(directionsButton.data("url"), "_blank", "noopener");
          return false;
        }
        // Elsewhere in the hover card only "More info" opens the job.
        const hoverCard = $(jsEvent.target).closest(".card-hover-block");
        if (
          hoverCard.length &&
          !$(jsEvent.target).closest(".card-more-button").length
        ) {
          return false;
        }
        router.navigate(`/dashboard/jobs/${calEvent.jobId}`);
      },
      eventRender: (event, element, view) => {
        // Cards dropped from the side panels render before the calendar
        // refetches and have no endForDisplay yet; use their own end.
        const endForDisplay = event.endForDisplay || event.end || event.start;
        if (event.rendering === "background") {
          element.css("background-color", "#F5F7FA");

          var text = event.notes;
          var canvas = document.createElement("canvas");
          var fontSize = 20;
          canvas.setAttribute("height", 34);
          var context = canvas.getContext("2d");

          var color1 = "#FFB1CF",
            color2 = "#F5F7FA";
          var numberOfStripes = 100;
          for (var i = 0; i < numberOfStripes * 2; i++) {
            var thickness = 600 / numberOfStripes;
            context.beginPath();
            context.strokeStyle = i % 2 ? color1 : color2;
            context.lineWidth = i % 2 ? thickness / 5 : thickness;
            context.lineCap = "round";

            context.moveTo(i * thickness + thickness / 2 - 300, 0);
            context.lineTo(0 + i * thickness + thickness / 2, 300);
            context.stroke();
          }

          context.fillStyle = "#1D3041";
          context.fontSize = fontSize + "px";
          context.fillText(text, 0, fontSize);

          element.css({
            "background-image": "url(" + canvas.toDataURL("image/png") + ")",
          });
          return null;
        }
        if (
          (view.name === "basicWeek" || view.name === "timelineDay") &&
          event.isVacation
        ) {
          element
            .find(".fc-title")
            .css("height", 15)
            .css("border-radius", 10)
            .css("padding", "0 5");
          element.find(".fc-content").wrap("<div class='vacation-card'></div>");

          const endDate = event.end || event.start;
          const startDateFormatted = moment(event.start).format(
            "MMM D, YY h:mma"
          );
          const endDateFormatted = moment(endDate).format("MMM D, YY h:mma");
          const combined =
            moment(event.start).format("MMM D, YY h:mma") +
            " - " +
            moment(endDate).format("h:mma");
          const sameStartAndEnd =
            moment(event.start).format("MM/DD/YYYY") ===
            moment(endDate).format("MM/DD/YYYY");
          const morethanOnedayJob = `${startDateFormatted} - ${endDateFormatted}`;

          element
            .find(".fc-content")
            .append(
              "<div class='technician-name'><span>User -</span> " +
              event.user +
              "</div>"
            )
            .append(
              `<div class='vacation-date'>${sameStartAndEnd ? combined : morethanOnedayJob
              }</div>`
            );
        } else {
          element
            .find(".fc-title")
            //.css('background-color', event.statusColor)
            .css("height", 15)
            //.css('color', '#fff')
            .css("border-radius", 10)
            .css("padding", "0 5");
          if (view.name === "listDay" || view.name === "listWeek") {
            element
              .find(".fc-event-dot")
              .css("background-color", event.statusColor);

            element
              .find(".fc-list-item-title")
              .prepend(
                "<div class='card-top'>" +
                "<div class='event-number'>" +
                "#" +
                event.eventNumber +
                "</div>" +
                "<div class='event-tag'>" +
                event.serviceType.name +
                "</div>"
              )
              .append("<div class='client-name'>" + event.clientName + "</div>")
              .append(
                "<div class='technician-name'>" +
                event.technicianName +
                "</div>"
              );

            element.find(".fc-list-item-title a").hide();

            // For day list fix - removed undefined with time
            if (view.name === "listDay") {
              const timeRange =
                moment(event.start).format("h:mma") +
                " - " +
                moment(endForDisplay).format("h:mma");
              element.find(".fc-list-item-time").html(timeRange);
            }
          } else {
            let sideStatusIndicator = $(
              "<div class='fc-event-status-indicator'></div>"
            );
            if (view.name === "basicWeek") {
              sideStatusIndicator = sideStatusIndicator.css(
                "backgroundColor",
                "#FFFFFF"
              );
            } else {
              sideStatusIndicator = sideStatusIndicator.css(
                "backgroundColor",
                event.statusColor
              );
            }

            element.find(".fc-content").before(sideStatusIndicator);

            // if (event.isRecurringJob) {
            //   element
            //     .find(".fc-content")
            //     .append("<span class='bp3-icon-standard bp3-icon-repeat'></span>");
            // }

            const startDateFormatted = moment(event.start).format(
              "MMM D, YY h:mma"
            );
            const endDateFormatted = moment(endForDisplay).format(
              "MMM D, YY h:mma"
            );
            const combined =
              moment(event.start).format("MMM D, YY h:mma") +
              " - " +
              moment(endForDisplay).format("h:mma");
            const sameStartAndEnd =
              moment(event.start).format("MM/DD/YYYY") ===
              moment(endForDisplay).format("MM/DD/YYYY");

            var morethanOnedayJob = `${startDateFormatted} - ${endDateFormatted}`;

            // Hover card extras the job card itself doesn't show.
            const jobStatus = event.job_status || event.status;
            const statusBadge = jobStatus
              ? `<span class='h-status not-draggable'><span class='h-status-dot' style='background-color: ${event.statusColor || "#9aa5b5"};'></span>${_.startCase(jobStatus)}</span>`
              : "";
            const priorityMapping = event.priority
              ? this.getPriorityMapping(event.priority)
              : null;
            const priorityBadge = priorityMapping
              ? `<span class='priority-tag not-draggable' style='background-color: ${priorityMapping.background}; color: ${priorityMapping.text}; border-color: ${priorityMapping.text};'>${priorityMapping.emoji} ${priorityMapping.label}</span>`
              : "";
            const durationMinutes = moment(endForDisplay).diff(
              moment(event.start),
              "minutes"
            );
            const durationParts = [
              [Math.floor(durationMinutes / 1440), "d"],
              [Math.floor((durationMinutes % 1440) / 60), "h"],
              [durationMinutes % 60, "m"],
            ].filter(([amount]) => amount > 0);
            const duration = durationParts
              .map(([amount, unit]) => `${amount}${unit}`)
              .join(" ");
            const destination =
              event.latitude && event.longitude
                ? `${event.latitude},${event.longitude}`
                : event.fullAddress;
            const directionsUrl = destination
              ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination).replace(/'/g, "%27")}`
              : null;
            const technicians = _.isArray(event.technicianName)
              ? event.technicianName.join(", ")
              : event.technicianName;

            var html = `<div class='card-top not-draggable'> <div class='event-number not-draggable'> #${event.eventNumber
              } </div> <div class='event-tag not-draggable'> ${event.serviceType.name
              } </div></div>
          <div class='h-client-title not-draggable'><span class="for-span not-draggable">For </span> ${event.title
              } </div>
          ${statusBadge || priorityBadge
                ? `<div class='h-badges not-draggable'>${statusBadge}${priorityBadge}</div>`
                : ""
              }
          <div class="not-draggable"><ul class="list-unstyled">
          <li class='h-client icon-marker not-draggable'>${event.clientName
              }</li>
          <li class='h-client-address not-draggable'>${event.fullAddress}</li>
          ${technicians
                ? `<li class='h-client icon-user not-draggable'>${technicians}</li>`
                : ""
              }
          <li class='h-card-date icon-calender not-draggable'>${sameStartAndEnd ? combined : morethanOnedayJob
              }${duration ? `<span class='h-duration'> · ${duration}</span>` : ""
              }</li>
          ${event.isRecurringJob
                ? "<li class='h-recurring not-draggable'><span class='bp3-icon-standard bp3-icon-repeat'></span> Part of a service agreement</li>"
                : ""
              }
          </ul></div>
          <div class='add-task-button not-draggable'><button type='button' class='card-edit-button'><span class='bp3-icon-standard bp3-icon-edit'></span> Edit</button>${directionsUrl
                ? `<button type='button' class='card-directions-button' data-url='${directionsUrl}'><span class='bp3-icon-standard bp3-icon-direction-right'></span> Directions</button>`
                : ""
              }<button type='button' class='card-more-button'>More info</button></div>
          `;
            let afterNinePm =
              (moment(endForDisplay).get("date") ==
                moment.unix(Number(date)).get("date") &&
                moment(endForDisplay).get("hour") >= 21) ||
              moment(endForDisplay).get("date") >
              moment.unix(Number(date)).get("date");

            let card = element
              .find(".fc-content")
              .prepend(
                `<div class='card-hover-block ${afterNinePm ? "bottom-config" : ""
                }'>` +
                html +
                "</div>"
              )
              .prepend(
                `<div class='card-top'><div class='event-wrapper'><div class='event-number'> #${event.eventNumber
                }</div><div class='repeat-job ${event.isRecurringJob ? "" : "hide"
                }'><span class='bp3-icon-standard bp3-icon-repeat repeat-icon-new'></span></div><div class='invoiced-job ${isInvoicedJob(event) ? "" : "hide"
                }'><span class='bp3-icon-standard bp3-icon-tick-circle bp3-intent-success tick-icon'></span></div></div><div class='event-tag'>${event.serviceType.name
                }</div></div>`
              )
              .append(
                "<div class='card-row'>" +
                "<div class='client-name-bold'>" +
                event.clientName +
                "</div>" +
                (event.priority ? (
                  (() => {
                    const mapping = this.getPriorityMapping(event.priority);
                    return `<div class='priority-tag' style='background-color: ${mapping.background}; color: ${mapping.text}; border-color: ${mapping.text};'>${mapping.emoji} ${mapping.label}</div>`;
                  })()
                ) : "") +
                "</div></div>"
              )
              .append(
                "<div class='card-row'>" +
                "<div class='full-address'>" +
                event.fullAddress +
                "</div>" +
                "</div>"
              );

            if (_.isArray(event.technicianName)) {
              _.forEach(event.technicianName, function (technician) {
                if (event.assignments && event.assignments.length > 0) {
                  let assignment = _.find(event.assignments, function (obj) {
                    return obj.technician_name === technician;
                  });
                  if (assignment && assignment.color) {
                    card.append(
                      "<div class='card-row'>" +
                      "<div class='technician-name'>" +
                      "<div class='docs-color-bubble' style='margin-right: 5px; background-color:" +
                      assignment.color +
                      "'" +
                      "></div>" +
                      technician +
                      "</div>" +
                      "</div>"
                    );
                  } else {
                    card.append(
                      "<div class='card-row'>" +
                      "<div class='technician-name'>" +
                      technician +
                      "</div></div>"
                    );
                  }
                } else {
                  card.append(
                    "<div class='card-row'>" +
                    "<div class='technician-name'>" +
                    technician +
                    "</div></div>"
                  );
                }
              });
            } else {
              card.append(
                "<div class='card-row'>" +
                "<div class='technician-name'>" +
                event.technicianName +
                "</div></div>"
              );
            }
            if (sameStartAndEnd) {
              card.append(
                "<div class='card-bottom'>" +
                "<div class='card-date'>" +
                combined +
                "</div>" +
                "</div>"
              );
            } else {
              card.append(
                "<div class='card-bottom'>" +
                "<div class='card-date'>" +
                startDateFormatted +
                " - " +
                endDateFormatted +
                "</div>" +
                "</div>"
              );
            }
          }
          element
            .find(".event-tag")
            .css("backgroundColor", `#${event.serviceType.color}`);

          if (isInvoicedJob(event)) {
            element.addClass("invoicedJobBgColor");
          }
        }
      },
      // Hover cards are handled by one delegated listener (componentDidMount);
      // binding here added another set to every job on every render.
      eventAfterAllRender: function (view) {
        renderWorkloadMeters(view);
      },
      resources: loadCalendarUsers.bind(dashboard),
      events: loadCalendarAssignments.bind(dashboard),
      eventOverlap: function (stillEvent, movingEvent) {
        return stillEvent.rendering !== "background" && !stillEvent.isVacation;
      },
    });
    if (view === "basicWeek" || view === "timelineDay") {
      $("#calendar").fullCalendar("option", "displayEventTime", false);
    } else {
      $("#calendar").fullCalendar("option", "displayEventTime", true);
    }
  }

  componentDidMount() {
    channels
      .dispatchBoard()
      .bind("assignment-state-change", () => {
        whenNotDragging("refetch", () => $("#calendar").fullCalendar("refetchEvents"));
      })
      .bind("toast-notification", (event) => {
        try {
          var audio = new Audio("music_marimba_chord.wav");
          audio.play();
        } catch (err) {
          // log to rollbar here
        }
        Toast.show({
          icon: "notifications",
          message: event.message,
          intent: "primary",
          timeout: 15000,
        });
      });

    this.renderCalendar();

    // Show a job's hover card; hide the others (and all of them mid-drag).
    // Hiding waits a moment so the pointer can cross the gap between the job
    // and its card; the card sits inside the job, so reaching it re-enters.
    const HOVER_CARD_HIDE_DELAY = 300;
    let hoverCardHideTimer = null;
    const cancelHoverCardHide = () => {
      clearTimeout(hoverCardHideTimer);
      hoverCardHideTimer = null;
    };
    this.cancelHoverCardHide = cancelHoverCardHide;
    $("#calendar")
      .off(".hovercard")
      .on("mouseenter.hovercard", ".fc-event", function () {
        cancelHoverCardHide();
        if (document.body.classList.contains("dispatch-dragging")) return;
        const card = $(this).find(".card-hover-block");
        $("#calendar .card-hover-block").not(card).hide();
        card.show();
      })
      .on("mouseleave.hovercard", ".fc-event", function () {
        const card = $(this).find(".card-hover-block");
        cancelHoverCardHide();
        hoverCardHideTimer = setTimeout(() => {
          hoverCardHideTimer = null;
          card.hide();
        }, HOVER_CARD_HIDE_DELAY);
      });

    var pageX_Drag, pageY_Drag;
    var disableDragSelector = ".fc-event";

    var calendarElement = $("#calendar");
    calendarElement.on("mousedown", ".fc-scroller", function (e) {
      var dragDisabledElms = $(e.target)
        .parents(disableDragSelector)
        .addBack(disableDragSelector);
      if (dragDisabledElms.length) return;

      pageX_Drag = e.pageX;
      pageY_Drag = e.pageY;

      $(window).off("mousemove", __mouseMove_Drag);
      $(window).on("mousemove", __mouseMove_Drag);
    });

    $(window).on("mouseup", __mouseUp_Drag);

    function __mouseUp_Drag() {
      $(window).off("mousemove", __mouseMove_Drag);
    }

    function __mouseMove_Drag(evt) {
      var offsetX = pageX_Drag - evt.pageX;
      var offsetY = pageY_Drag - evt.pageY;

      $(".fc-scroller", calendarElement).each(function () {
        var scroller = $(this);
        var newX = scroller.scrollLeft() + offsetX;
        var newY = scroller.scrollTop() + offsetY;

        scroller.scrollLeft(newX);
        scroller.scrollTop(newY);
      });

      pageX_Drag = evt.pageX;
      pageY_Drag = evt.pageY;
    }

    setTimeout(() => {
      this.onUnassignedOpen();
    }, 4000);

    setTimeout(() => {
      this.onInconpleteJobsOpen();
    }, 4500);
  }

  changeView = (view) => {
    let { viewStore } = this.props;
    viewStore.dashboardSearch.view = view;
    viewStore.dashboard();
    this.renderCalendar();
    $("#calendar").fullCalendar("changeView", view);
    $("#calendar").fullCalendar("render");
  };

  // Saves a drop, move or resize from the calendar.
  // Timeline: the row is a technician, so assign to it ("0" is the
  //   Unassigned row) and save the new date and time.
  // Week view: no technician rows, and its events are jobs, not
  //   assignments. PUT /jobs/:id only accepts assignment updates (a job id
  //   returns a 500), so move each of the job's assignments to the new dates,
  //   re-sending its own technician and status so both stay as they are.
  updateJob = (job) => {
    const dates = {
      id: job.id,
      start_date: job.start.toISOString(),
      end_date: job.end.toISOString(),
    };
    const viewName = $("#calendar").fullCalendar("getView").name;
    if (viewName !== "timelineDay" || job.resourceId == null) {
      // Panel cards dropped here are a single assignment themselves.
      const assignments =
        job.assignments && job.assignments.length
          ? job.assignments
          : [{ id: job.id, user_id: job.user_id, status: job.status }];
      return Promise.all(
        assignments.map((assignment) =>
          this.props.jobStore.updateJob({
            ...dates,
            id: assignment.id,
            technician_id: assignment.user_id || "0",
            status: assignment.status,
          })
        )
      );
    }

    let status;
    if (job.resourceId !== "0" && job.status === "unassigned") {
      status = "assigned";
    } else if (job.resourceId === "0" && job.status !== "unassigned") {
      status = "unassigned";
    } else {
      status = job.status;
    }
    return this.props.jobStore.updateJob({
      ...dates,
      technician_id: job.resourceId === 0 ? null : job.resourceId,
      status: status,
    });
  };

  onInconpleteJobsOpen = () => {
    this.props.jobStore.loadIncompleteJobs();
  };

  onUnassignedOpen = () => {
    // The panel attaches dragging to its cards after every render.
    this.props.jobStore.loadUnassignedJobs();
    //this.props.store.isOpenUnassignedJob = !this.props.store.isOpenUnassignedJob
  };

  onServiceTypeChange(selections) {
    let selectedValues = selections.map((status) => status.value);
    let {
      props: {
        viewStore: { dashboardSearch },
      },
    } = this;

    this.props.viewStore.dashboardSearch = {
      ...dashboardSearch,
      service_type_id: selectedValues,
    };
    this.props.viewStore.dashboard();
    $("#calendar").fullCalendar("refetchEvents");
  }

  onTechnicianChange(technicians) {
    let selectedValues = technicians.map((status) => status.value);
    let {
      props: {
        viewStore: { dashboardSearch },
      },
    } = this;

    this.props.viewStore.dashboardSearch = {
      ...dashboardSearch,
      technician_id: toJS(selectedValues),
    };
    this.props.viewStore.dashboard();
    $("#calendar").fullCalendar("refetchResources");
    $("#calendar").fullCalendar("refetchEvents");
  }

  onPriorityChange(priorities) {
    let {
      props: {
        viewStore: { dashboardSearch },
      },
    } = this;

    let selectedValues = priorities.map((p) => p.value);

    this.props.viewStore.dashboardSearch = {
      ...dashboardSearch,
      priority: toJS(selectedValues),
    };
    this.props.viewStore.dashboard();
    $("#calendar").fullCalendar("refetchResources");
    $("#calendar").fullCalendar("refetchEvents");
  }

  render() {
    const { isBoxVisible } = this.state;
    let {
      props: {
        dashboard,
        viewStore: {
          dashboardSearch: { date, service_type_id, technician_id, priority, view },
        },
      },
    } = this;
    let buttonDate = moment.unix(date).format("ddd, MMM D, YYYY");

    return (
      <div
        className="responsive-layout-navbar dispatch-board"
        style={{
          zIndex: -2,
          height: "calc(100vh - 130px)",
          backgroundColor: "#ffffff",
          paddingRight: "10px",
          paddingLeft: "10px",
        }}
      >
        <Helmet>
          <title>Dispatch Board | Field Nexus</title>
        </Helmet>

        <div className="dispatch-board-header">
          <SearchFiltersToolbar
            className="filter-bar--stretch"
            header={
              <DispatchViewBar
                current={{ timelineDay: "timeline", basicWeek: "week" }[view]}
                status={dashboard.isLoading && <Spinner size={16} />}
              >
                <Button
                  className="zoom-btn"
                  onClick={() => {
                    this.zoom_in = true;
                  }}
                  icon="zoom-in"
                />
              </DispatchViewBar>
            }
          >
            <Popover
              content={this.datePicker.bind(this)(date)}
              position={Position.BOTTOM_LEFT}
              usePortal={true}
            >
              <Button
                className="filter-date"
                icon="calendar"
                rightIcon="caret-down"
                text={buttonDate}
              />
            </Popover>
            <ServiceTypePicker
              selectedOptions={service_type_id || []}
              maximumSelections={10}
              onChange={this.onServiceTypeChange.bind(this)}
              includeSelectAll={true}
            />
            <TechnicianPicker
              selectedOptions={technician_id || []}
              onChange={this.onTechnicianChange.bind(this)}
              includeAdmins={true}
              includeUnassigned={true}
              includeSelectAll={true}
            />
            <PriorityTagPicker
              selectedOptions={toJS(priority) || []}
              onChange={this.onPriorityChange.bind(this)}
              includeSelectAll={true}
            />
          </SearchFiltersToolbar>
        </div>

        <div className="dispatch-board-wrapper">
          {/* <input type="checkbox" id="navigation" className="btn-unssg" defaultChecked={true} /> */}
          {/* <label htmlFor="navigation" className="button-open"> <span>Unassigned Jobs</span> </label> */}
          <label
            htmlFor="navigation"
            className={`button-open ${isBoxVisible ? "" : "right"} ${isBoxVisible && this.currentSideTab === "unassignedJobs"
              ? "active"
              : ""
              }`}
            onClick={() => {
              this.toggleBox("unassignedJobs");
            }}
          >
            {" "}
            <span>Unassigned Jobs</span>{" "}
          </label>
          <label
            htmlFor="navigation"
            className={`button-open inCompleteJobBtn ${isBoxVisible ? "" : "right"
              } ${isBoxVisible && this.currentSideTab === "incompleteJobs"
                ? "active"
                : ""
              }`}
            onClick={() => {
              this.toggleBox("incompleteJobs");
            }}
          >
            {" "}
            <span>Incomplete Jobs</span>{" "}
          </label>
          <div className={`section ${isBoxVisible ? "" : "hidden"}`}>
            <div id="full-calender" className={this.zoom_in ? "zoom-in" : ""}>
              {this.zoom_in && (
                <div className="calender-status-bar" id="statusBar">
                  <div className="current-data-time">
                    <Popover
                      content={this.datePicker.bind(this)(date)}
                      position={Position.BOTTOM_LEFT}
                      style={{ padding: "10px" }}
                      usePortal={true}
                    >
                      <Button rightIcon="caret-down" icon="calendar">
                        {buttonDate}
                      </Button>
                    </Popover>
                    {dashboard.isLoading && (
                      <Button minimal={true}>
                        <Spinner size={24}></Spinner>
                      </Button>
                    )}
                  </div>
                  <div className="zoom-out">
                    <a
                      href="javascript:;"
                      onClick={() => {
                        this.zoom_in = false;
                      }}
                      id="zoomOut"
                    >
                      <Icon icon="zoom-out" />
                    </a>
                  </div>
                </div>
              )}
              <div id="calendar"></div>
              {/* <div className='calender-wrap'>
                <a
                  className="btn-unassigned-job"
                  href="javascript:"
                  onClick={this.onUnassignedOpen}>Unassigned Jobs</a>
              </div> */}
            </div>
          </div>
          <div className={`usg-job-panel ${isBoxVisible ? "" : "hidden"}`}>
            {this.currentSideTab === "unassignedJobs" && <UnassignedJob />}
            {this.currentSideTab === "incompleteJobs" && <IncompleteJob />}
          </div>
        </div>
      </div>
    );
  }
}

export default DispatchBoard;
